import i18n from "../i18n";
import { useState } from "react";
import { Tabs } from "@mantine/core";
import OrderCommissionSetting from "./orderCommissionSetting";
import OrderCommissionPaymentList from "./orderCommissionPaymentList";

const OrderCommission = ({ form, values }) => {
  const [paymentsRefreshKey, setPaymentsRefreshKey] = useState(0);
  const refreshCommissionPayments = () =>
    setPaymentsRefreshKey((key) => key + 1);

  return (
    <Tabs variant="outline" defaultValue="setting" size="xs" mt="md">
      <Tabs.List>
        <Tabs.Tab value="setting">{i18n.t("Commission Setting")}</Tabs.Tab>
        <Tabs.Tab value="payments">{i18n.t("Commission Payments")}</Tabs.Tab>
      </Tabs.List>
      <Tabs.Panel value="setting" pt="xl">
        <OrderCommissionSetting
          form={form}
          values={values}
          onCommissionPaymentsRefresh={refreshCommissionPayments}
        />
      </Tabs.Panel>
      <Tabs.Panel value="payments" pt="xl">
        <OrderCommissionPaymentList
          form={form}
          values={values}
          refreshKey={paymentsRefreshKey}
        />
      </Tabs.Panel>
    </Tabs>
  );
};

export default OrderCommission;
